import gql from 'graphql-tag';

import { VendorDetails } from '../../../../graphql/fragments/account';

const getGlobalPrintProductAlbumCustomPrint = gql`
  query getGlobalPrintProductAlbumCustomPrint {
    globalAlbumCustomPrint(custom_print_type: PRINT_PRODUCT) {
      id
      custom_print {
        id
        account {
          ...VendorDetails
        }
      }
    }
  }
  ${VendorDetails}
`;

export default getGlobalPrintProductAlbumCustomPrint;
